/**
 * utm is appended to href that links to doist.com or twist.com
 * @param {string} url
 * @param {object} params
 */

export default function appendUTM(
    url,
    {
        utm_source = 'todoist',
        utm_medium = 'landing_page',
        utm_campaign = 'home',
        utm_content,
    } = {},
) {
    let paramsString = `utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`
    if (utm_content) {
        paramsString += `&utm_content=${utm_content}`
    }

    const [urlWithoutHash, hashValue] = url.split('#')
    const urlWithParams = `${urlWithoutHash}${
        !urlWithoutHash.includes('?') ? '?' : '&'
    }${paramsString}`
    const fullUrl = `${urlWithParams}${hashValue ? `#${hashValue}` : ''}`

    return fullUrl
}
